import { useLayoutEffect, useState } from 'react';

// Keep large client lists out of the DOM while retaining native table scrolling.
export default function useClientTableWindow(clients) {
  const [container, setContainer] = useState(null);
  const [viewport, setViewport] = useState({ top: 0, height: 800, rowHeight: 49 });
  const enabled = clients.length > 100;

  useLayoutEffect(() => {
    if (!container) return;
    container.scrollTop = 0;
    const measure = () => {
      const rowHeight = container.querySelector('tr[data-client-row]')?.getBoundingClientRect().height || 49;
      const headerHeight = container.querySelector('thead')?.getBoundingClientRect().height || 0;
      const next = { top: Math.max(0, container.scrollTop - headerHeight), height: container.clientHeight, rowHeight };
      setViewport(previous => previous.top === next.top && previous.height === next.height && previous.rowHeight === next.rowHeight ? previous : next);
    };
    measure();
    container.addEventListener('scroll', measure, { passive: true });
    const observer = new ResizeObserver(measure);
    observer.observe(container);
    const row = container.querySelector('tr[data-client-row]');
    if (row) observer.observe(row);
    return () => {
      container.removeEventListener('scroll', measure);
      observer.disconnect();
    };
  }, [container, clients]);

  const start = enabled ? Math.min(Math.max(0, clients.length - 1), Math.max(0, Math.floor(viewport.top / viewport.rowHeight) - 10)) : 0;
  const end = enabled ? Math.min(clients.length, start + Math.ceil(viewport.height / viewport.rowHeight) + 21) : clients.length;
  return {
    tableRef: setContainer,
    rows: enabled ? clients.slice(start, end) : clients,
    start,
    paddingTop: start * viewport.rowHeight,
    paddingBottom: (clients.length - end) * viewport.rowHeight,
  };
}
